module.exports = __webpack_public_path__ + "img/london-business.19f51872.jpg";